import {
  StockCountItem,
  StockInventory,
  StockInventoryReportItem,
} from "@/modules/StockInventory/Types/StockInventory.types";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";

const API_URL = import.meta.env.VITE_API_URL;

type GetInventoryStockOptions = {
  status?: string[];
  search?: string;
  page?: number;
  itemsPerPage?: string;
};

const makeRequestDebouncedStockInventory = createDebounce(makeRequest, 200);
export async function getStockInventory(
  options: GetInventoryStockOptions = {}
) {
  const { status = [], search = "", page = 1, itemsPerPage = "30" } = options;
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
  });
  let statusParam = "";
  if (Array.isArray(status) && status.length > 0) {
    statusParam = status.join(",");
  } else if (typeof status === "string") {
    statusParam = status;
  }
  status && params.append("filters[status]", statusParam);
  search && params.append("search", search);

  const url = `${API_URL}/stock-inventory?${params.toString()}`;
  const result = (await makeRequestDebouncedStockInventory(
    url
  )) as ApiResponseType<StockInventory[]> & { totalItems: number };

  return { ok: result.ok, data: result.data, totalItems: result.totalItems };
}

export async function createStockInventory(data: { observations: string }) {
  const url = `${API_URL}/stock-inventory`;
  const result = (await makeRequest(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })) as ApiResponseType<StockInventory>;

  return result;
}

export async function getStockInventoryById(id: string) {
  const url = `${API_URL}/stock-inventory/${id}`;
  const result = (await makeRequest(url)) as ApiResponseType<StockInventory>;
  return result;
}

export async function getStockInventoryReportDetails(id: string) {
  const url = `${API_URL}/stock-inventory/${id}/report-details`;
  const result = (await makeRequest(url)) as ApiResponseType<
    StockInventoryReportItem[]
  >;
  return result;
}

export async function getStockInventoryAuditReportDetails(id: string) {
  const url = `${API_URL}/stock-inventory/${id}/audit-report-details`;
  const result = (await makeRequest(url)) as ApiResponseType<
    StockInventoryReportItem[]
  >;
  return result;
}

export async function confirmInventoryCount(
  inventoryId: string,
  items: StockCountItem[]
) {
  const url = `${API_URL}/stock-inventory/${inventoryId}/confirm-count`;
  const result = (await makeRequest(url, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items }),
  })) as ApiResponseType<StockInventory>;

  return result;
}
